export const removeNonNumericCharacters = (phone: string) => {
  return phone.replace(/\D/g, "");
};